var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-img',{staticClass:"check-verified",attrs:{"src":require("@/assets/images/elements/verified.png")}})}
var staticRenderFns = []

export { render, staticRenderFns }